export const formatDateInTimezone = (date, timezone, isEndDate = false) => {
    if (!date) return 'Not set';
    // Create a UTC date at midnight (or end of day for end dates)
    const utcDate = new Date(date);
    if (isEndDate) {
        utcDate.setUTCHours(23, 59, 59, 0);
    } else {
        utcDate.setUTCHours(0, 0, 0, 0);
    }
    
    // Format the date in the requested timezone
    return utcDate.toLocaleString('en-US', {
        timeZone: timezone,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false
    });
};

// Function to format date in YYYY-MM-DD format
export const formatDateSimple = (date) => {
    if (!date) return 'Not set';
    const d = new Date(date);
    if (isNaN(d.getTime())) return 'Not set';
    return d.toISOString().split('T')[0]; // Returns YYYY-MM-DD format
}; 